import React from "react";
import cx from "classnames";
import styles from "./Alert.module.scss";

export interface AlertProps {
  className?: string;
  theme?: "neutral" | "success" | "danger";
  onDismiss?: () => void;
}

const Alert: React.FC<AlertProps> = ({ className, children, theme = "neutral", onDismiss }) => {
  return (
    <div
      className={cx(styles.alert, className, {
        [styles.neutral]: theme === "neutral",
        [styles.success]: theme === "success",
        [styles.danger]: theme === "danger",
      })}
      role="alert"
    >
      <div className={styles.body}>
        {typeof children === "string" ? <p>{children}</p> : children}
      </div>
      {onDismiss && (
        <button
          type="button"
          className={styles.dismissButton}
          aria-label="Close"
          onClick={onDismiss}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      )}
    </div>
  );
};

export default Alert;
